export const HOME = "/home";
export const PORTFOLIO = "/portfolio";
export const ABOUTUS = "/aboutus";
export const SERVICES = "/services";
export const PARTNERS = "/partners";
export const CONTACTS = "/contacts";
